<template>
  <div class="seasonContainer">
    <div class="leaderboardWrapper">
      <SeasonLeaderboardList :is-jackpot="false" :checked-historical-season="prevSeasonId" />
    </div>
    <button class="btn-primary openBtn" @click="openHandler">
      <span class="btn-text">{{ $t('seasonEndedInfoCurrentSeason') }}</span>
      <span>&#10132;</span>
    </button>
  </div>
</template>

<script lang="ts" setup>
import { SeasonModalView } from '~/types/season';

const emit = defineEmits<{ updateModalView: [modalView: SeasonModalView] }>();

const prevSeasonId = inject<Ref<number>>('prevSeasonId');

const openHandler = () => {
  emit('updateModalView', SeasonModalView.start);
};
</script>

<style lang="scss" scoped>
.seasonContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.leaderboardWrapper {
  width: 100%;
  max-height: 50vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  :deep(.contentWrapperExtraStyle.maxHeightLeaderboard) {
    max-height: 50vh !important;
    height: auto !important;
  }

  @media screen and (max-width: 560px) {
    max-height: 40vh;

    :deep(.contentWrapperExtraStyle.maxHeightLeaderboard) {
      max-height: 40vh !important;
    }
  }
}

.openBtn {
  font-size: 20px;
  height: 62px;
  padding: 0 40px;
  flex-shrink: 0;

  @media screen and (max-width: 479px) {
    margin-bottom: 25px;
  }
}
.btn-text {
  margin-right: 12px;
}
</style>
